import React, { useRef, useEffect } from 'react';
import { getCdnImage, SITE_IMAGES } from '../data/content';

export function VideoSection({
  title = 'Se hvorfor Click-Click metoden er genial',
  subtitle = 'I denne officielle præsentation ser du, hvorfor SYSTEM 3E ændrer måden, vi opfører vægge på i moderne byggeri.',
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch((err) => {
              console.log('Autoplay was prevented by browser:', err);
            });
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(video);

    return () => {
      if (video) observer.unobserve(video);
    };
  }, []);

  return (
    <section className="my-0 py-12 md:py-16 bg-[#F0F0F0] text-slate-900 relative w-full">
      <div className="p-6 md:p-10 max-w-5xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 tracking-tight mb-3">
          {title}
        </h2>
        <p className="text-slate-600 text-sm md:text-base max-w-2xl mx-auto mb-8">
          {subtitle}
        </p>

        {/* Responsive Video Container - Full Height */}
        <div className="relative w-full overflow-hidden bg-[#F0F0F0]">
          <video
            ref={videoRef}
            src="https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/pagevideo03.mp4"
            poster={getCdnImage(SITE_IMAGES.clickClickDemo, 1200, 85)}
            muted
            loop
            playsInline
            preload="metadata"
            className="w-full h-auto block bg-[#F2F3F0] scale-[1.01] origin-center"
          >
            Din browser understøtter ikke HTML5 video.
          </video>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-6 text-xs text-slate-600 font-medium">
          <span className="flex items-center gap-1.5">
            <i className="fa-solid fa-bolt text-[#446ba9]" aria-hidden="true" />
            Ingen mørtel eller lim
          </span>
          <span className="flex items-center gap-1.5">
            <i className="fa-solid fa-shield-halved text-[#446ba9]" aria-hidden="true" />
            REI 240 + M Brandtestet
          </span>
          <span className="flex items-center gap-1.5">
            <i className="fa-solid fa-cubes text-[#446ba9]" aria-hidden="true" />
            100% tør modulopbygning
          </span>
        </div>
      </div>
    </section>
  );
}
